module.exports = __webpack_public_path__ + "fonts/okticon.db28723126138387cdf40680e6e0fa5d.woff?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/okticon.woff
// module id = 720
// module chunks = 9